import React from 'react';
import { Table } from 'react-bootstrap';

/**
 * The striped single-column table used by list screens: a `.scrollable-table`
 * wrapper, one `<th>` heading, and a `<tbody>` of rows (usually
 * <ExpandableRow>s). Shows `emptyState` when there are no children.
 *
 * Used directly by modal-only list screens, and internally by CrudListShell.
 */
const CompactListTable = ({ tableHeading, emptyState, scrollable = true, children }) => {
  const hasRows = React.Children.count(children) > 0;

  const table = (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>{tableHeading}</th>
        </tr>
      </thead>
      <tbody>{hasRows ? children : emptyState}</tbody>
    </Table>
  );

  return scrollable ? <div className="scrollable-table">{table}</div> : table;
};

export default CompactListTable;
